(function() {
  var STORAGE_KEY = 'breadcrumb_source_section_v1';
  var MAX_AGE_MS = 10 * 60 * 1000;
  var HEADING_SELECTORS = [
    '.product-slider--heading',
    '.featured-collection--heading',
    '.featured-heading',
    '.section-title',
    '.section-heading',
    '.heading',
    'h1', 'h2', 'h3'
  ];
  var BLACKLIST_PATTERNS = [
    'product-recommendations',
    'product_recommendations',
    'recently-viewed',
    'recently_viewed',
    'related-products',
    'related_products'
  ];

  function isBlacklistedSection(section) {
    if (!section) return true;
    var combined = ((section.id || '') + ' ' + (section.className || '')).toLowerCase();
    for (var i = 0; i < BLACKLIST_PATTERNS.length; i++) {
      if (combined.indexOf(BLACKLIST_PATTERNS[i]) !== -1) return true;
    }
    return false;
  }

  function findSectionHeading(link) {
    var section = link.closest('.shopify-section');
    if (!section) return null;
    if (isBlacklistedSection(section)) return null;
    for (var i = 0; i < HEADING_SELECTORS.length; i++) {
      var el = section.querySelector(HEADING_SELECTORS[i]);
      if (el) {
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (text) return text;
      }
    }
    return null;
  }

  function findSectionUrl(link) {
    var section = link.closest('.shopify-section');
    if (!section) return null;
    var ctaLink = section.querySelector('a[href*="/collections/"]');
    return ctaLink ? ctaLink.getAttribute('href') : null;
  }

  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    var title = findSectionHeading(link);
    if (!title) return;
    var sectionUrl = findSectionUrl(link);
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        title: title,
        url: sectionUrl,
        fromPath: window.location.pathname,
        timestamp: Date.now()
      }));
    } catch (err) {}
  }, true);

  function updateBreadcrumb() {
    var placeholder = document.querySelector('[data-breadcrumb-source]');
    if (!placeholder) return;
    var raw;
    try { raw = sessionStorage.getItem(STORAGE_KEY); } catch (err) { return; }
    if (!raw) return;
    var data;
    try { data = JSON.parse(raw); } catch (err) { return; }
    if (!data || !data.title) return;
    if (Date.now() - data.timestamp > MAX_AGE_MS) {
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (err) {}
      return;
    }

    var slash = document.createElement('i');
    slash.textContent = '/';
    var label;
    if (data.url) {
      label = document.createElement('a');
      label.setAttribute('href', data.url);
    } else {
      label = document.createElement('span');
    }
    label.textContent = data.title;
    placeholder.appendChild(slash);
    placeholder.appendChild(label);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBreadcrumb);
  } else {
    updateBreadcrumb();
  }
})();
